import PropTypes from 'prop-types';

export const TaxAccountingPropTypes = PropTypes.shape({
  periodName: PropTypes.string,
  taxDescription: PropTypes.string,
  enabledFlag: PropTypes.string.isRequired,
  plAccount: PropTypes.string,
  bsAccount: PropTypes.string,
  reclassPlAccount: PropTypes.string,
  reclassBsAccount: PropTypes.string,
  goldId: PropTypes.string,
});

export const TaxAccountingsPropTypes = PropTypes.arrayOf(TaxAccountingPropTypes).isRequired;
